import { render, staticRenderFns } from "./SpTwoModule3.vue?vue&type=template&id=15060ade&scoped=true"
import script from "./SpTwoModule3.vue?vue&type=script&lang=js"
export * from "./SpTwoModule3.vue?vue&type=script&lang=js"
import style0 from "./SpTwoModule3.vue?vue&type=style&index=0&id=15060ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15060ade",
  null
  
)

export default component.exports